import React from "react";

function DrawPadItem(props) {
    return null
}

export default DrawPadItem